
      window.global = window.global || window;
    